// sl-707
// sachin

import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './CustomModal.css'
import { useAlert } from 'react-alert';

const FeatureRequestModal = ({ show, handleClose, handleConfirm }) => {

    const alert = useAlert()
    const [input, setInput] = useState("")

    const handleSubmit = () => {
        if (input === undefined || input === "" || input === null || input.trim("") === "") {
            return alert.info("Please specify your requirement.")
        }
        handleConfirm(input, "OTHERS")
    }

    const styles = {
        textarea: {
            width: "100%",
            marginTop: "10px",
            padding: "4px",
            fontSize: "15px"
        },
        text: {
            ReqDesTitle: {
                textAlign: "left",
                fontWeight: "600"
            },
            title: {
                fontSize: "18px"
            }
        },
        modal: {
            header: {
                border: "none",
                flexFlow: "column-reverse"
            }
        },
        container: {
            button: {
                display: "inlineFlex",
                marginTop: "10px"
            }
        },
        button: {
            submit: {
                minWidth: "80px",
                padding: "5px 3px",
                width: "60px",
                marginRight: "10px",
                border: "none",
                fontSize: "12px",
                background: "#339a99",
                color: "white"
            },
            cancel: {
                minWidth: "80px",
                padding: "5px 3px",
                marginLeft: "10px",
                background: "#c5d6d6",
                border: "none",
                fontSize: "12px"
            }
        }
    }

    return (
        <Modal className="featureRequestModal" style={styles.modal} centered show={show} onHide={handleClose}>
            <Modal.Header style={styles.modal.header}>
                <Modal.Title style={styles.text.title}>New Feature Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={styles.text.ReqDesTitle}>Request description</p>
                <textarea rows={4} style={styles.textarea} onChange={(e) => setInput(e.target.value)}></textarea>
                <div style={styles.container.button}>
                    <button style={styles.button.submit} onClick={() => handleSubmit()}>
                        SUBMIT
                    </button>
                    <button style={styles.button.cancel} onClick={() => handleClose()}>
                        CANCEL
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default FeatureRequestModal;
